import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2 } from '@eppendorf/vnls-react-components-preview';
import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { subscriptionNavigationPath } from '$components/subscription-dialog/subscription-dialog';

import './billing-user-hint.scss';

export function BillingUserHint(): ReactElement {
  const { t } = useTranslation();

  return (
    <div
      className="billing-user-hint flex p-left-m p-right-m p-top-l p-bottom-l m-bottom-xxl border-color-blue-500 bg-blue-50 border-solid border-radius-xs"
      role="note"
    >
      <Icon name="info" size={IconSizeClasses.XSmall} className="bg-blue-600 m-right-s" />
      <p className="billing-user-hint__message">
        <Trans
          i18nKey="userManagement.billingUserHint"
          components={{
            strong: <strong />,
            subscriptionLink: (
              <a
                href={subscriptionNavigationPath}
                target="_blank"
                rel="noopener noreferrer"
                className="color-blue-500"
              >
                {t('subscription.manageSubscription')}
              </a>
            ),
          }}
        />
      </p>
      <ButtonV2
        variant="primary"
        className="billing-user-hint__action m-left-l"
        onPress={() =>
          window.open(subscriptionNavigationPath, '_blank', 'noopener,noreferrer')
        }
      >
        {t('subscription.manageSubscription')}
        <Icon
          name="external-link"
          size={IconSizeClasses.XXSmall}
          className="m-left-xs bg-white"
        />
      </ButtonV2>
    </div>
  );
}
